/**
 * 8.8 Κωδικός Κατηγορίας Χαρακτηρισμού Εσόδων
 */
/** Πώληση Εμπορευμάτων */
export const saleOfMerchandise = "category1_1";
/** Πώληση Προϊόντων */
export const saleOfProducts = "category1_2";
/** Παροχή Υπηρεσιών */
export const saleOfServices = "category1_3";
/** Πώληση Παγίων */
export const saleOfAsset = "category1_4";
/** Λοιπά Έσοδα Κέρδη */
export const otherIncome = "category1_5";
/** Αυτοπαραδόσεις Ιδιοχρησιμοποιήσεις */
export const selfConsumptionIncome = "category1_6";
/** Έσοδα Για Λογαριασμό Τρίτων */
export const incomeThirdParty = "category1_7";
/** Έσοδα Προηγούμενων Χρήσεων */
export const pastIncome = "category1_8";
/** Έσοδα Eπόμενων Xρήσεων */
export const futureIncome = "category1_9";
/** Λοιπές Εγγραφές Τακτοποίησης Εσόδων */
export const otherIncomeSettlementEntry = "category1_10";
/** Λοιπά Πληροφοριακά Στοιχεία Εσόδων */
export const otherIncomeInfoEntry = "category1_95";

export const incomeCategory = [
  saleOfMerchandise,
  saleOfProducts,
  saleOfServices,
  saleOfAsset,
  otherIncome,
  selfConsumptionIncome,
  incomeThirdParty,
  pastIncome,
  futureIncome,
  otherIncomeSettlementEntry,
  otherIncomeInfoEntry,
] as const;
export type IncomeCategory = typeof incomeCategory[number];
export const isIncomeCategory = (input: unknown): input is IncomeCategory =>
  typeof input === "string" && incomeCategory.includes(input as any);

/**
 * 8.10 Κωδικός Κατηγορίας Χαρακτηρισμού Εξόδων
 */
/** 2.1 Αγορές Εμπορευμάτων */
export const purchaseOfMerchandise = "category2_1";
/** 2.2 Αγορές Α'-Β' Υλών */
export const purchaseOfRawMaterials = "category2_2";
/** 2.3 Λήψη Υπηρεσιών */
export const purchaseOfServices = "category2_3";
/** 2.4 Γενικά Έξοδα με δικαίωμα έκπτωσης ΦΠΑ */
export const generalExpensesWithVATDiscount = "category2_4";
/** 2.5 Γενικά Έξοδα χωρίς δικαίωμα έκπτωσης ΦΠΑ */
export const generalExpensesWithoutVATDiscount = "category2_5";
/** 2.6 Αμοιβές και Παροχές προσωπικού */
export const payrollAndBenefits = "category2_6";
/** 2.7 Αγορές Παγίων */
export const purchaseOfAssets = "category2_7";
/** 2.8 Αποσβέσεις Παγίων */
export const recupOfAssets = "category2_8";
/** 2.9 Έξοδα για λ/σμο τρίτων */
export const expensesOnBehalfOfOthers = "category2_9";
/** 2.10 Έξοδα προηγούμενων χρήσεων */
export const pastExpenses = "category2_10";
/** 2.11 Έξοδα επομένων χρήσεων */
export const futureExpenses = "category2_11";
/** 2.12 Λοιπές Εγγραφές Τακτοποίησης Εξόδων */
export const otherEntryExpenseSettlement = "category2_12";
/** 2.13 Αποθέματα Έναρξης Περιόδου */
export const reservesAtBeginningOfPeriod = "category2_13";
/** 2.14 Αποθέματα Λήξης Περιόδου */
export const reservesAtEndOfPeriod = "category2_14";
/** 2.15 Λοιπά Πληροφοριακά Στοιχεία Εξόδων */
export const expensesOtherInfoEntry = "category2_95";
export const expensesCategory = [
  purchaseOfMerchandise,
  purchaseOfRawMaterials,
  purchaseOfServices,
  generalExpensesWithVATDiscount,
  generalExpensesWithoutVATDiscount,
  payrollAndBenefits,
  purchaseOfAssets,
  recupOfAssets,
  expensesOnBehalfOfOthers,
  pastExpenses,
  futureExpenses,
  otherEntryExpenseSettlement,
  reservesAtBeginningOfPeriod,
  reservesAtEndOfPeriod,
  expensesOtherInfoEntry,
] as const;

export type ExpensesCategory = typeof expensesCategory[number];
export const isExpensesCategory = (input: unknown): input is ExpensesCategory =>
  typeof input === "string" && expensesCategory.includes(input as any);

export const classificationCategory = [
  ...incomeCategory,
  ...expensesCategory,
] as const;
export type ClassificationCategory = ExpensesCategory | IncomeCategory;
export const isClassificationCategory = (
  input: unknown
): input is ClassificationCategory =>
  isIncomeCategory(input) || isExpensesCategory(input);

/**
 * 8.10 Κωδικός Κατηγορίας Χαρακτηρισμού Εξόδων
 */
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Εμπορεύματα */
export const E3_106 = "E3_106";
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά */
export const E3_205 = "E3_205";
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη */
export const E3_210 = "E3_210";
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις – Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά */
export const E3_305 = "E3_305";
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη */
export const E3_310 = "E3_310";
/** Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Έξοδα παραγωγής */
export const E3_318 = "E3_318";
/** Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών */
export const E3_561_001 = "E3_561_001";
/** Πωλήσεις αγαθών και υπηρεσιών Χονδρικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000) */
export const E3_561_002 = "E3_561_002";
/** Πωλήσεις αγαθών και υπηρεσιών Λιανικές - Ιδιωτική Πελατεία */
export const E3_561_003 = "E3_561_003";
/** Πωλήσεις αγαθών και υπηρεσιών Λιανικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000) */
export const E3_561_004 = "E3_561_004";
/** Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Ενδοκοινοτικές */
export const E3_561_005 = "E3_561_005";
/** Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Τρίτες Χώρες */
export const E3_561_006 = "E3_561_006";
/** Πωλήσεις αγαθών και υπηρεσιών Λοιπά */
export const E3_561_007 = "E3_561_007";
/** Λοιπά συνήθη έσοδα */
export const E3_562 = "E3_562";
/** Πιστωτικοί τόκοι και συναφή έσοδα */
export const E3_563 = "E3_563";
/** Πιστωτικές συναλλαγματικές διαφορές */
export const E3_564 = "E3_564";
/** Έσοδα συμμετοχών */
export const E3_565 = "E3_565";
/** Κέρδη από διάθεση μη κυκλοφορούντων περιουσιακών στοιχείων */
export const E3_566 = "E3_566";
/** Κέρδη από αναστροφή προβλέψεων και απομειώσεων */
export const E3_567 = "E3_567";
/** Κέρδη από επιμέτρηση στην εύλογη αξία */
export const E3_568 = "E3_568";
/** Ασυνήθη έσοδα και κέρδη */
export const E3_570 = "E3_570";
/** Έξοδα σε ιδιοπαραγωγή */
export const E3_595 = "E3_595";
/** Επιδοτήσεις - Επιχορηγήσεις */
export const E3_596 = "E3_596";
/** Επιδοτήσεις - Επιχορηγήσεις για επενδυτικούς σκοπούς - κάλυψη δαπανών */
export const E3_597 = "E3_597";
/** Πωλήσεις Παγίων Χονδρικές */
export const E3_880_001 = "E3_880_001";
/** Πωλήσεις Παγίων Λιανικές */
export const E3_880_002 = "E3_880_002";
/** Πωλήσεις Παγίων Εξωτερικού Ενδοκοινοτικές */
export const E3_880_003 = "E3_880_003";
/** Πωλήσεις Παγίων Εξωτερικού Τρίτες Χώρες */
export const E3_880_004 = "E3_880_004";
/** Πωλήσεις για λογ/σμο Τρίτων Χονδρικές */
export const E3_881_001 = "E3_881_001";
/** Πωλήσεις για λογ/σμο Τρίτων Λιανικές */
export const E3_881_002 = "E3_881_002";
/** Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Ενδοκοινοτικές */
export const E3_881_003 = "E3_881_003";
/** Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Τρίτες Χώρες */
export const E3_881_004 = "E3_881_004";
/** Πωλήσεις αγαθών που υπάγονται σε ΕΦΚ */
export const E3_598_001 = "E3_598_001";
/** Πωλήσεις για λογαριασμό αγροτών μέσω αγροτικού συνεταιρισμού κ.λ.π. */
export const E3_598_003 = "E3_598_003";
export const incomeType = [
  E3_106,
  E3_205,
  E3_210,
  E3_305,
  E3_310,
  E3_318,
  E3_561_001,
  E3_561_002,
  E3_561_003,
  E3_561_004,
  E3_561_005,
  E3_561_006,
  E3_561_007,
  E3_562,
  E3_563,
  E3_564,
  E3_565,
  E3_566,
  E3_567,
  E3_568,
  E3_570,
  E3_595,
  E3_596,
  E3_597,
  E3_880_001,
  E3_880_002,
  E3_880_003,
  E3_880_004,
  E3_881_001,
  E3_881_002,
  E3_881_003,
  E3_881_004,
  E3_598_001,
  E3_598_003,
] as const;
export type IncomeType = typeof incomeType[number];
export const isIncomeType = (input: unknown): input is IncomeType =>
  typeof input === "string" && incomeType.includes(input as any);

/** Εμπορεύματα έναρξης */
export const E3_101 = "E3_101";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Χονδρικές */
export const E3_102_001 = "E3_102_001";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Λιανικές */
export const E3_102_002 = "E3_102_002";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Αγαθών του άρθρου 39α παρ.5 του Κώδικα Φ.Π.Α. (ν.2859/2000) */
export const E3_102_003 = "E3_102_003";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές */
export const E3_102_004 = "E3_102_004";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες */
export const E3_102_005 = "E3_102_005";
/** Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)Λοιπά */
export const E3_102_006 = "E3_102_006";
/** Εμπορεύματα λήξης */
export const E3_104 = "E3_104";
/** Πρώτες ύλες και υλικά έναρξης/Παραγωγή */
export const E3_201 = "E3_201";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές */
export const E3_202_001 = "E3_202_001";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές */
export const E3_202_002 = "E3_202_002";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές */
export const E3_202_003 = "E3_202_003";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες */
export const E3_202_004 = "E3_202_004";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά */
export const E3_202_005 = "E3_202_005";
/** Αποθέματα λήξης πρώτων υλών και υλικών/Παραγωγή */
export const E3_204 = "E3_204";
/** Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Παραγωγή */
export const E3_207 = "E3_207";
/** Προϊόντα και παραγωγή σε εξέλιξη λήξης/Παραγωγή */
export const E3_209 = "E3_209";
/** Πρώτες ύλες και υλικά έναρξης/Αγροτική */
export const E3_301 = "E3_301";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές */
export const E3_302_001 = "E3_302_001";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές */
export const E3_302_002 = "E3_302_002";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές */
export const E3_302_003 = "E3_302_003";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες */
export const E3_302_004 = "E3_302_004";
/** Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά */
export const E3_302_005 = "E3_302_005";
/** Αποθέματα λήξης πρώτων υλών και υλικών/Αγροτική */
export const E3_304 = "E3_304";
/** Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Αγροτική */
export const E3_307 = "E3_307";
/** Προϊόντα και παραγωγή σε εξέλιξη λήξης/Αγροτική */
export const E3_309 = "E3_309";
/** Αποθέματα έναρξης (ζώων - φυτών) */
export const E3_312 = "E3_312";
/** Αγορές ζώων - φυτών (καθαρό ποσό)/Χονδρικές */
export const E3_313_001 = "E3_313_001";
/** Αγορές ζώων - φυτών (καθαρό ποσό)/Λιανικές */
export const E3_313_002 = "E3_313_002";
/** Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές */
export const E3_313_003 = "E3_313_003";
/** Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες */
export const E3_313_004 = "E3_313_004";
/** Αγορές ζώων - φυτών (καθαρό ποσό)/Λοιπά */
export const E3_313_005 = "E3_313_005";
/** Αποθέματα τέλους (ζώων - φυτών)/Αγροτική */
export const E3_315 = "E3_315";
/** Παροχές σε εργαζόμενους/Μικτές αποδοχές */
export const E3_581_001 = "E3_581_001";
/** Παροχές σε εργαζόμενους/Εργοδοτικές εισφορές */
export const E3_581_002 = "E3_581_002";
/** Παροχές σε εργαζόμενους/Λοιπές παροχές */
export const E3_581_003 = "E3_581_003";
/** Ζημιές επιμέτρησης περιουσιακών στοιχείων */
export const E3_582 = "E3_582";
/** Χρεωστικές συναλλαγματικές διαφορές */
export const E3_583 = "E3_583";
/** Ζημιές από διάθεση-απόσυρση μη κυκλοφορούντων περιουσιακών στοιχείων */
export const E3_584 = "E3_584";
/** Προμήθειες διαχείρισης ημεδαπής - αλλοδαπής (management fees) */
export const E3_585_001 = "E3_585_001";
/** Δαπάνες από συνδεδεμένες επιχειρήσεις */
export const E3_585_002 = "E3_585_002";
/** Δαπάνες από μη συνεργαζόμενα κράτη ή από κράτη με προνομιακό φορολογικό καθεστώς */
export const E3_585_003 = "E3_585_003";
/** Δαπάνες για ενημερωτικές ημερίδες */
export const E3_585_004 = "E3_585_004";
/** Έξοδα υποδοχής και φιλοξενίας */
export const E3_585_005 = "E3_585_005";
/** Έξοδα ταξιδιών */
export const E3_585_006 = "E3_585_006";
/** Ασφαλιστικές Εισφορές Αυτοαπασχολούμενων */
export const E3_585_007 = "E3_585_007";
/** Έξοδα και προμήθειες παραγγελιοδόχου για λογαριασμό αγροτών */
export const E3_585_008 = "E3_585_008";
/** Λοιπές Αμοιβές για υπηρεσίες ημεδαπής */
export const E3_585_009 = "E3_585_009";
/** Λοιπές Αμοιβές για υπηρεσίες αλλοδαπής */
export const E3_585_010 = "E3_585_010";
/** Ενέργεια */
export const E3_585_011 = "E3_585_011";
/** Ύδρευση */
export const E3_585_012 = "E3_585_012";
/** Τηλεπικοινωνίες */
export const E3_585_013 = "E3_585_013";
/** Ενοίκια */
export const E3_585_014 = "E3_585_014";
/** Διαφήμιση και προβολή */
export const E3_585_015 = "E3_585_015";
/** Λοιπά έξοδα */
export const E3_585_016 = "E3_585_016";
/** Χρεωστικοί τόκοι και συναφή έξοδα */
export const E3_586 = "E3_586";
/** Αποσβέσεις */
export const E3_587 = "E3_587";
/** Ασυνήθη έξοδα, ζημιές και πρόστιμα */
export const E3_588 = "E3_588";
/** Προβλέψεις (εκτός από προβλέψεις για το προσωπικό) */
export const E3_589 = "E3_589";
/** Αγορές ενσώματων παγίων χρήσης/Χονδρικές */
export const E3_882_001 = "E3_882_001";
/** Αγορές ενσώματων παγίων χρήσης/Λιανικές */
export const E3_882_002 = "E3_882_002";
/** Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές */
export const E3_882_003 = "E3_882_003";
/** Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες */
export const E3_882_004 = "E3_882_004";
/** Αγορές μη ενσώματων παγίων χρήσης/Χονδρικές */
export const E3_883_001 = "E3_883_001";
/** Αγορές μη ενσώματων παγίων χρήσης/Λιανικές */
export const E3_883_002 = "E3_883_002";
/** Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές */
export const E3_883_003 = "E3_883_003";
/** Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες */
export const E3_883_004 = "E3_883_004";
/** Αγορές & δαπάνες στο εσωτερικό της χώρας */
export const VAT_361 = "VAT_361";
/** Αγορές & εισαγωγές επενδ. Αγαθών (πάγια) */
export const VAT_362 = "VAT_362";
/** Λοιπές εισαγωγές εκτός επενδ. Αγαθών (πάγια) */
export const VAT_363 = "VAT_363";
/** Ενδοκοινοτικές αποκτήσεις αγαθών */
export const VAT_364 = "VAT_364";
/** Ενδοκοινοτικές λήψεις υπηρεσιών άρθρ. 14.2.α */
export const VAT_365 = "VAT_365";
/** Λοιπές πράξεις λήπτη */
export const VAT_366 = "VAT_366";

/** Απομείωση εμπορευμάτων */
export const E3_103 = "E3_103";
/** Απομείωση πρώτων υλών και υλικών */
export const E3_203 = "E3_203";
/** Απομείωση πρώτων υλών και υλικών */
export const E3_303 = "E3_303";
/** Απομείωση προϊόντων και παραγωγής σε εξέλιξη */
export const E3_208 = "E3_208";
/** Απομείωση προϊόντων και παραγωγής σε εξέλιξη */
export const E3_308 = "E3_308";
/** Απομείωση ζώων - φυτών – εμπορευμάτων */
export const E3_314 = "E3_314";
/** Αγορές αγαθών που υπάγονται σε ΕΦΚ */
export const E3_598_002 = "E3_598_002";

export const expensesType = [
  E3_101,
  E3_102_001,
  E3_102_002,
  E3_102_003,
  E3_102_004,
  E3_102_005,
  E3_102_006,
  E3_104,
  E3_201,
  E3_202_001,
  E3_202_002,
  E3_202_003,
  E3_202_004,
  E3_202_005,
  E3_204,
  E3_207,
  E3_209,
  E3_301,
  E3_302_001,
  E3_302_002,
  E3_302_003,
  E3_302_004,
  E3_302_005,
  E3_304,
  E3_307,
  E3_309,
  E3_312,
  E3_313_001,
  E3_313_002,
  E3_313_003,
  E3_313_004,
  E3_313_005,
  E3_315,
  E3_581_001,
  E3_581_002,
  E3_581_003,
  E3_582,
  E3_583,
  E3_584,
  E3_585_001,
  E3_585_002,
  E3_585_003,
  E3_585_004,
  E3_585_005,
  E3_585_006,
  E3_585_007,
  E3_585_008,
  E3_585_009,
  E3_585_010,
  E3_585_011,
  E3_585_012,
  E3_585_013,
  E3_585_014,
  E3_585_015,
  E3_585_016,
  E3_586,
  E3_587,
  E3_588,
  E3_589,
  E3_882_001,
  E3_882_002,
  E3_882_003,
  E3_882_004,
  E3_883_001,
  E3_883_002,
  E3_883_003,
  E3_883_004,
  VAT_361,
  VAT_362,
  VAT_363,
  VAT_364,
  VAT_365,
  VAT_366,
  E3_103,
  E3_203,
  E3_303,
  E3_208,
  E3_308,
  E3_314,
  E3_106,
  E3_205,
  E3_305,
  E3_210,
  E3_310,
  E3_318,
  E3_598_002,
] as const;

export type ExpensesType = typeof expensesType[number];
export const isExpensesType = (input: unknown): input is ExpensesType =>
  typeof input === "string" && expensesType.includes(input as any);

export const classificationType = [...incomeType, ...expensesType] as const;
export type ClassificationType = IncomeType | ExpensesType;
export const isClassificationType = (
  input: unknown
): input is ClassificationType => isIncomeType(input) || isExpensesType(input);

export const classificationCategoryNames: Record<
  ClassificationCategory,
  string
> = {
  [saleOfMerchandise]: "Πώληση Εμπορευμάτων",
  [saleOfProducts]: "Πώληση Προϊόντων",
  [saleOfServices]: "Παροχή Υπηρεσιών",
  [saleOfAsset]: "Πώληση Παγίων",
  [otherIncome]: "Λοιπά Έσοδα Κέρδη",
  [selfConsumptionIncome]: "Αυτοπαραδόσεις - Ιδιοχρησιμοποιήσεις",
  [incomeThirdParty]: "Έσοδα Για Λογαριασμό Τρίτων",
  [pastIncome]: "Έσοδα Προηγούμενων Χρήσεων",
  [futureIncome]: "Έσοδα Eπόμενων Xρήσεων",
  [otherIncomeSettlementEntry]: "Λοιπές Εγγραφές Τακτοποίησης Εσόδων",
  [otherIncomeInfoEntry]: "Λοιπά Πληροφοριακά Στοιχεία Εσόδων",
  [purchaseOfMerchandise]: "Αγορές Εμπορευμάτων",
  [purchaseOfRawMaterials]: "Αγορές Α'-Β' Υλών",
  [purchaseOfServices]: "Λήψη Υπηρεσιών",
  [generalExpensesWithVATDiscount]: "Γενικά Έξοδα με δικαίωμα έκπτωσης ΦΠΑ",
  [generalExpensesWithoutVATDiscount]:
    "Γενικά Έξοδα χωρίς δικαίωμα έκπτωσης ΦΠΑ",
  [payrollAndBenefits]: "Αμοιβές και Παροχές προσωπικού",
  [purchaseOfAssets]: "Αγορές Παγίων",
  [recupOfAssets]: "Αποσβέσεις Παγίων",
  [expensesOnBehalfOfOthers]: "Έξοδα για λ/σμο τρίτων",
  [pastExpenses]: "Έξοδα προηγούμενων χρήσεων",
  [futureExpenses]: "Έξοδα επομένων χρήσεων",
  [otherEntryExpenseSettlement]: "Λοιπές Εγγραφές Τακτοποίησης Εξόδων",
  [reservesAtBeginningOfPeriod]: "Αποθέματα Έναρξης Περιόδου",
  [reservesAtEndOfPeriod]: "Αποθέματα Λήξης Περιόδου",
  [expensesOtherInfoEntry]: "Λοιπά Πληροφοριακά Στοιχεία Εξόδων",
};

export const classificationTypeNames: Record<ClassificationType, string> = {
  E3_106:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Εμπορεύματα",

  E3_205:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά",

  E3_210:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη",

  E3_305:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις – Καταστροφές αποθεμάτων/Πρώτες ύλες και λοιπά υλικά",

  E3_310:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Προϊόντα και παραγωγή σε εξέλιξη",

  E3_318:
    "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων/Έξοδα παραγωγής",

  E3_561_001: "Πωλήσεις αγαθών και υπηρεσιών Χονδρικές - Επιτηδευματιών",

  E3_561_002:
    "Πωλήσεις αγαθών και υπηρεσιών Χονδρικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000)",

  E3_561_003: "Πωλήσεις αγαθών και υπηρεσιών Λιανικές - Ιδιωτική Πελατεία",

  E3_561_004:
    "Πωλήσεις αγαθών και υπηρεσιών Λιανικές βάσει άρθρου 39α παρ 5 του Κώδικα Φ.Π.Α. (Ν.2859/2000)",

  E3_561_005: "Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Ενδοκοινοτικές",

  E3_561_006: "Πωλήσεις αγαθών και υπηρεσιών Εξωτερικού Τρίτες Χώρες",

  E3_561_007: "Πωλήσεις αγαθών και υπηρεσιών Λοιπά",

  E3_562: "Λοιπά συνήθη έσοδα",

  E3_563: "Πιστωτικοί τόκοι και συναφή έσοδα",

  E3_564: "Πιστωτικές συναλλαγματικές διαφορές",

  E3_565: "Έσοδα συμμετοχών",

  E3_566: "Κέρδη από διάθεση μη κυκλοφορούντων περιουσιακών στοιχείων",

  E3_567: "Κέρδη από αναστροφή προβλέψεων και απομειώσεων",

  E3_568: "Κέρδη από επιμέτρηση στην εύλογη αξία",

  E3_570: "Ασυνήθη έσοδα και κέρδη",

  E3_595: "Έξοδα σε ιδιοπαραγωγή",

  E3_596: "Επιδοτήσεις - Επιχορηγήσεις",

  E3_597:
    "Επιδοτήσεις - Επιχορηγήσεις για επενδυτικούς σκοπούς - κάλυψη δαπανών",

  E3_880_001: "Πωλήσεις Παγίων Χονδρικές",

  E3_880_002: "Πωλήσεις Παγίων Λιανικές",

  E3_880_003: "Πωλήσεις Παγίων Εξωτερικού Ενδοκοινοτικές",

  E3_880_004: "Πωλήσεις Παγίων Εξωτερικού Τρίτες Χώρες",

  E3_881_001: "Πωλήσεις για λογ/σμο Τρίτων Χονδρικές",

  E3_881_002: "Πωλήσεις για λογ/σμο Τρίτων Λιανικές",

  E3_881_003: "Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Ενδοκοινοτικές",

  E3_881_004: "Πωλήσεις για λογ/σμο Τρίτων Εξωτερικού Τρίτες Χώρες",
  E3_101: "Εμπορεύματα έναρξης",
  E3_102_001: "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Χονδρικές",
  E3_102_002: "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Λιανικές",
  E3_102_003:
    "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Αγαθών του άρθρου 39α παρ.5 του Κώδικα Φ.Π.Α. (ν.2859/2000)",
  E3_102_004:
    "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές",
  E3_102_005:
    "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες",
  E3_102_006: "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)Λοιπά",
  E3_104: "Εμπορεύματα λήξης",
  E3_201: "Πρώτες ύλες και υλικά έναρξης/Παραγωγή",
  E3_202_001: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές",
  E3_202_002: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές",
  E3_202_003:
    "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές",
  E3_202_004:
    "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες",
  E3_202_005: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά",
  E3_204: "Αποθέματα λήξης πρώτων υλών και υλικών/Παραγωγή",
  E3_207: "Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Παραγωγή",
  E3_209: "Προϊόντα και παραγωγή σε εξέλιξη λήξης/Παραγωγή",
  E3_301: "Πρώτες ύλες και υλικά έναρξης/Αγροτική",
  E3_302_001: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές",
  E3_302_002: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές",
  E3_302_003:
    "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές",
  E3_302_004:
    "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες",
  E3_302_005: "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά",
  E3_304: "Αποθέματα λήξης πρώτων υλών και υλικών/Αγροτική",
  E3_307: "Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Αγροτική",
  E3_309: "Προϊόντα και παραγωγή σε εξέλιξη λήξης/Αγροτική",
  E3_312: "Αποθέματα έναρξης (ζώων - φυτών)",
  E3_313_001: "Αγορές ζώων - φυτών (καθαρό ποσό)/Χονδρικές",
  E3_313_002: "Αγορές ζώων - φυτών (καθαρό ποσό)/Λιανικές",
  E3_313_003: "Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές",
  E3_313_004: "Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες",
  E3_313_005: "Αγορές ζώων - φυτών (καθαρό ποσό)/Λοιπά",
  E3_315: "Αποθέματα τέλους (ζώων - φυτών)/Αγροτική",
  E3_581_001: "Παροχές σε εργαζόμενους/Μικτές αποδοχές",
  E3_581_002: "Παροχές σε εργαζόμενους/Εργοδοτικές εισφορές",
  E3_581_003: "Παροχές σε εργαζόμενους/Λοιπές παροχές",
  E3_582: "Ζημιές επιμέτρησης περιουσιακών στοιχείων",
  E3_583: "Χρεωστικές συναλλαγματικές διαφορές",
  E3_584:
    "Ζημιές από διάθεση-απόσυρση μη κυκλοφορούντων περιουσιακών στοιχείων",
  E3_585_001: "Προμήθειες διαχείρισης ημεδαπής - αλλοδαπής (management fees)",
  E3_585_002: "Δαπάνες από συνδεδεμένες επιχειρήσεις",
  E3_585_003:
    "Δαπάνες από μη συνεργαζόμενα κράτη ή από κράτη με προνομιακό φορολογικό καθεστώς",
  E3_585_004: "Δαπάνες για ενημερωτικές ημερίδες",
  E3_585_005: "Έξοδα υποδοχής και φιλοξενίας",
  E3_585_006: "Έξοδα ταξιδιών",
  E3_585_007: "Ασφαλιστικές Εισφορές Αυτοαπασχολούμενων",
  E3_585_008: "Έξοδα και προμήθειες παραγγελιοδόχου για λογαριασμό αγροτών",
  E3_585_009: "Λοιπές Αμοιβές για υπηρεσίες ημεδαπής",
  E3_585_010: "Λοιπές Αμοιβές για υπηρεσίες αλλοδαπής",
  E3_585_011: "Ενέργεια",
  E3_585_012: "Ύδρευση",
  E3_585_013: "Τηλεπικοινωνίες",
  E3_585_014: "Ενοίκια",
  E3_585_015: "Διαφήμιση και προβολή",
  E3_585_016: "Λοιπά έξοδα",
  E3_586: "Χρεωστικοί τόκοι και συναφή έξοδα",
  E3_587: "Αποσβέσεις",
  E3_588: "Ασυνήθη έξοδα, ζημιές και πρόστιμα",
  E3_589: "Προβλέψεις (εκτός από προβλέψεις για το προσωπικό)",
  E3_882_001: "Αγορές ενσώματων παγίων χρήσης/Χονδρικές",
  E3_882_002: "Αγορές ενσώματων παγίων χρήσης/Λιανικές",
  E3_882_003: "Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές",
  E3_882_004: "Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες",
  E3_883_001: "Αγορές μη ενσώματων παγίων χρήσης/Χονδρικές",
  E3_883_002: "Αγορές μη ενσώματων παγίων χρήσης/Λιανικές",
  E3_883_003: "Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές",
  E3_883_004: "Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες",
  VAT_361: "Αγορές & δαπάνες στο εσωτερικό της χώρας",
  VAT_362: "Αγορές & εισαγωγές επενδ. Αγαθών (πάγια)",
  VAT_363: "Λοιπές εισαγωγές εκτός επενδ. Αγαθών (πάγια)",
  VAT_364: "Ενδοκοινοτικές αποκτήσεις αγαθών",
  VAT_365: "Ενδοκοινοτικές λήψεις υπηρεσιών άρθρ. 14.2.α",
  VAT_366: "Λοιπές πράξεις λήπτη",
  E3_103: "Απομείωση εμπορευμάτων",
  E3_203: "Απομείωση πρώτων υλών και υλικών",
  E3_303: "Απομείωση πρώτων υλών και υλικών",
  E3_208: "Απομείωση προϊόντων και παραγωγής σε εξέλιξη",
  E3_308: "Απομείωση προϊόντων και παραγωγής σε εξέλιξη",
  E3_314: "Απομείωση ζώων - φυτών – εμπορευμάτων",
  E3_598_001: "Πωλήσεις αγαθών που υπάγονται σε ΕΦΚ",
  E3_598_002: "Αγορές αγαθών που υπάγονται σε ΕΦΚ",
  E3_598_003:
    "Πωλήσεις για λογαριασμό αγροτών μέσω αγροτικού συνεταιρισμού κ.λ.π.",
};
